import { appLanguage as adminLogin } from "./Login/index.i18n";
import { appLanguage as adminSidebar } from "./SideBar/index.i18n";
import { appLanguage as desktop } from "./Desktop/index.i18n";
import { appLanguage as common } from "./Common/index.i18n";
import { appLanguage as employees } from "./Employees/index.i18n";
import { appLanguage as myteam } from "./MyTeam/index.i18n";
import { appLanguage as onborading } from "./Onboarding/index.i18n";
import { appLanguage as myopinion } from "./MyOpinion/index.i18n";
import { appLanguage as news } from "./News/index.i18n";
import { appLanguage as keys } from "./Keys/index.i18n";
import { appLanguage as agenda } from "./Agenda/index.i18n";
import { appLanguage as box } from "./Box/index.i18n";
import { appLanguage as academy } from "./Academy/index.i18n";
import { appLanguage as mydevelopment } from "./MyDevelopment/index.i18n";
import { appLanguage as headers } from "./Headers/index.i18n";
import { appLanguage as settings } from "./Settings/index.i18n";
import { appLanguage as hrms } from "./Hrms/index.i18n";
import { appLanguage as otp } from "./Otp/index.i18n";
export default function lang() {
  return {
    text: {
      adminLogin: adminLogin.text,
      adminSidebar: adminSidebar.text,
      desktop: desktop.text,
      common: common.text,
      employees: employees.text,
      myteam: myteam.text,
      onborading: onborading.text,
      myopinion: myopinion.text,
      news: news.text,
      keys: keys.text,
      agenda: agenda.text,
      box: box.text,
      academy: academy.text,
      mydevelopment: mydevelopment.text,
      headers: headers.text,
      settings: settings.text,
      hrms: hrms.text,
      otp: otp.text,
    },
  };
}
